var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found__box"},[_c('p',{staticClass:"not-found__code"},[_vm._v("404")]),_c('p',{staticClass:"not-found__desc"},[_vm._v("抱歉，您访问的页面不存在")]),_c('a',{staticClass:"not-found__btn",on:{"click":_vm.goHome}},[_vm._v("返回首页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }